export default __webpack_public_path__ + "static/media/login-bg-2.6736a075.png";